import { render, staticRenderFns } from "./MarketPreview.vue?vue&type=template&id=bffc318a&scoped=true&"
import script from "./MarketPreview.vue?vue&type=script&lang=js&"
export * from "./MarketPreview.vue?vue&type=script&lang=js&"
import style0 from "./MarketPreview.vue?vue&type=style&index=0&id=bffc318a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc318a",
  null
  
)

export default component.exports